// Friendly hero / welcome panel shown above the gallery grid.
// Tone: warm, family-friendly, written for visitors who are friends and family
// stopping by to see what Elias has been making.

export function Welcome() {
  return (
    <section className="relative overflow-hidden rounded-3xl border border-ink-900/10 bg-gradient-to-br from-canvas-100 via-canvas-50 to-white p-8 shadow-sm sm:p-12">
      <div className="pointer-events-none absolute -right-12 -top-12 h-48 w-48 rounded-full bg-accent/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-accent-soft/20 blur-3xl" />

      <div className="relative max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full border border-ink-900/10 bg-white/70 px-3 py-1 text-xs font-medium uppercase tracking-wider text-ink-700">
          <span className="h-1.5 w-1.5 rounded-full bg-accent" />
          Welcome to the gallery
        </span>
        <h1 className="mt-5 font-display text-4xl font-semibold leading-tight text-ink-900 sm:text-5xl">
          The art of <span className="text-accent">Elias</span>.
        </h1>
        <p className="mt-4 text-base leading-relaxed text-ink-700 sm:text-lg">
          Hi! Thanks for stopping by. This is a little corner of the internet for
          Elias's artwork — paintings, sketches, and whatever new thing he's
          been experimenting with this week. New pieces show up here as he
          finishes them, so check back from time to time.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-ink-500">
          Click any piece to see it full-size. Use the filters below to browse by
          category or by mood.
        </p>
      </div>
    </section>
  );
}
